import { Component } from '@angular/core';

@Component({
  selector: 'app-users-staff',
  imports: [],
  templateUrl: './users-staff.html',
  styleUrl: './users-staff.css'
})
export class UsersStaff {

}
